import { useMutation, useQueryClient } from '@tanstack/react-query';

import { showErrorToast } from '@hooks/showErrorToast';
import { request } from '@utils';

interface ImportTemplatePayload {
  declarantIds: string[];
  file: File;
}

export const useAdminImportTemplate = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: ImportTemplatePayload) => {
      const formData = new FormData();
      formData.append('file', payload.file);
      formData.append('declarantIds', payload.declarantIds.join(','));

      await request({
        path: 'template/import-template',
        method: 'POST',
        authenticate: true,
        dataObject: formData,
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
    },
    onSuccess: async () => {
      queryClient.invalidateQueries({ queryKey: ['admin-templates'] });
    },
    onError: (error) => {
      showErrorToast(error, 'Failed to import template');
    },
  });
};
